// eslint-disable-next-line no-restricted-globals
export const isNotANumber = (number: number) => isNaN(number);
